import React, { Component } from "react";
import PropTypes from "prop-types";
import { Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";
import { Input, Textarea } from "formsy-react-components";
import DropdownSearch from "../../common/DropdownSearch";

class ProjectTaskForm extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = { canSubmit: false };
  }

  onChange = (field, selected) => {
    this.setState({ [field]: selected.value });
  };

  enableButton = () => {
    this.setState({ canSubmit: true });
  };

  disableButton = () => {
    this.setState({ canSubmit: false });
  };

  add = (model) => {
    this.props.onAdd(model);
  };

  submit = (model) => {
    model.id = this.props.task._id;
    this.props.onSave(model);
  };

  cancel = () => {
    this.props.onCancel();
  };

  render() {
    const { project, task, users, codes, adding } = this.props;

    let hoursConsumed = project.tasks.reduce(
      (total, tsk) => total + tsk.estimated_hrs,
      0
    );

    hoursConsumed = !adding
      ? hoursConsumed - task.estimated_hrs
      : hoursConsumed;

    const hoursLeft = project.budget_hours - hoursConsumed;

    return (
      <Formsy
        ref={(ref) => (this.form = ref)}
        className="vertical form"
        onValidSubmit={adding ? this.add : this.submit}
        onValid={this.enableButton}
        onInvalid={this.disableButton}
      >
        <Row>
          <Col md={12} xs={12}>
            <Input
              formNoValidate
              required
              name="description"
              label="Description"
              value={task.description}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          <Col md={6} xs={12}>
            <DropdownSearch
              name="assigned_to"
              label="Assigned To"
              onChange={this.onChange}
              value={
                this.state.assigned_to ||
                (task.assigned_to && task.assigned_to._id)
              }
              data={[
                ...users.map((user) => ({
                  value: user._id,
                  label: `${user.first_name} ${user.last_name}`
                }))
              ]}
            />
          </Col>
          <Col md={3} xs={6}>
            <Input
              type="number"
              formNoValidate
              required
              name="estimated_hrs"
              label="Estimated Hrs"
              value={task.estimated_hrs}
              validations={{
                isBudgeted: (values, value) => value <= hoursLeft
              }}
              validationErrors={{
                isBudgeted: "Estimate must be within project budget hours"
              }}
            />
          </Col>
          <Col md={3} xs={6}>
            <DropdownSearch
              name="priority"
              label="Priority"
              onChange={this.onChange}
              value={this.state.priority || (task.priority && task.priority.id)}
              data={[
                ...codes
                  .filter((code) => code.field === "priority")
                  .map((code) => ({
                    value: code._id,
                    label: code.label
                  }))
              ]}
            />
          </Col>
          <Col md={12} xs={12}>
            <Textarea
              formNoValidate
              name="note"
              label="Note"
              value={task.note}
              validations={{ maxLength: 50 }}
              validationErrors={{
                maxLength: "You can not type in more than 50 characters"
              }}
            />
          </Col>
          <Col md={12} xs={12} className="footer">
            <button
              type="button"
              className="btn  btn-cancel"
              onClick={this.cancel}
            >
              Cancel
            </button>
            <input
              className="btn btn-success"
              type="submit"
              disabled={!this.state.canSubmit || this.props.saving}
              value={this.props.saving ? "Saving... " : "Save"}
            />
          </Col>
        </Row>
      </Formsy>
    );
  }
}

ProjectTaskForm.propTypes = {
  onSave: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  project: PropTypes.object.isRequired,
  saving: PropTypes.bool.isRequired,
  onAdd: PropTypes.func,
  task: PropTypes.object,
  users: PropTypes.array,
  codes: PropTypes.array,
  adding: PropTypes.bool
};

export default ProjectTaskForm;
